import { render } from "./HeadingField.vue?vue&type=template&id=75c076e2"
import script from "./HeadingField.vue?vue&type=script&lang=js"
export * from "./HeadingField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeadingField.vue"]])

export default __exports__